import React from 'react'

import { Divider, Typography } from 'antd'
import { DisclaimerAlert } from '@/src/components'

import Image from 'next/image'
import miniLogo from '@/public/assets/logo/miniLogo.png'

import { LegalContentItems } from '../../../interfaces'

const { Paragraph, Text, Title, Link } = Typography

interface LegalContentProps {
  content: LegalContentItems[]
  title: string
}

type LegalHeaderProps = {
  title: string
  date?: string
}

const LegalHeader = ({ title, date }: LegalHeaderProps) => {
  return (
    <>
      <div className='flex mx-auto items-center'>
        <Image src={miniLogo} alt='Avalon.AI Logo' width={80} height={80} />
        <div className='pl-8'>
          <Title level={2} style={{ margin: 0 }}>
            {title}
          </Title>
          {date && <Text>Last updated: {date}</Text>}
        </div>
      </div>
      <Divider />
    </>
  )
}
const LegalContent: React.FC<LegalContentProps> = ({ content, title }) => {
  return (
    <>
      {title === 'Terms of Use' && <DisclaimerAlert />}
      {content.map((item, index) => {
        switch (item.type) {
          case 'title':
            return (
              <Title key={index} level={item.level || 4}>
                {item.content}
              </Title>
            )
          case 'paragraph':
            return (
              <Paragraph key={index}>
                {item.content.split('[URL]').map((part, i) =>
                  i % 2 === 0 ? (
                    part
                  ) : (
                    <Link key={i} href={part}>
                      {part}
                    </Link>
                  )
                )}
              </Paragraph>
            )
          case 'list':
            return (
              <Paragraph key={index} className='pl-8'>
                <ul>
                  {item.items?.map((listItem, i) => (
                    <li key={i}>
                      <Text>{listItem}</Text>
                    </li>
                  ))}
                </ul>
              </Paragraph>
            )
          default:
            return null
        }
      })}
    </>
  )
}

export const LegalContentLayout = ({ title, content, date }: any) => {
  return (
    <div className='max-w-screen-xl px-4 mx-auto' data-testid='Terms'>
      <LegalHeader title={title} date={date} />
      <LegalContent content={content} title={title} />
    </div>
  )
}
